import type { Metadata } from "next";
import { LegalLayout, LegalSection } from "@/components/legal/legal-layout";

export const metadata: Metadata = {
  title: "Tuyên bố miễn trừ trách nhiệm",
  description:
    "Tử Vi Số chỉ mang tính tham khảo, không thay thế lời khuyên y tế / pháp lý / tài chính chuyên môn.",
};

export default function DisclaimerPage() {
  return (
    <LegalLayout
      title="Tuyên bố miễn trừ trách nhiệm"
      subtitle="Vui lòng đọc kỹ trước khi áp dụng kết quả từ Tử Vi Số vào quyết định cá nhân."
      lastUpdated="30/05/2026"
    >
      <div className="border-brand-red/30 bg-brand-red/10 mb-8 rounded-xl border p-5">
        <p className="text-ink-primary text-sm leading-relaxed font-medium">
          Mọi nội dung trên Tử Vi Số (lá số tử vi, phong thủy, ngày tốt, AI luận giải...){" "}
          <strong>chỉ mang tính tham khảo</strong> dựa trên cổ học phương Đông. Không thay thế lời
          khuyên chuyên môn của bác sĩ, luật sư, chuyên gia tài chính, hoặc nhà tư vấn hôn nhân.
        </p>
      </div>

      <LegalSection title="1. Bản chất của tử vi và phong thủy">
        <p>
          Tử vi đẩu số, bát trạch, lịch âm, kinh dịch... là di sản văn hoá cổ học, được nhiều thế hệ
          ghi chép. Đây là <strong>hệ thống biểu tượng</strong> phản ánh kinh nghiệm sống và quan
          sát tự nhiên, không phải khoa học thực nghiệm theo phương pháp khoa học hiện đại.
        </p>
      </LegalSection>

      <LegalSection title="2. AI luận giải có giới hạn">
        <p>Phản hồi AI dựa trên dữ liệu lá số bạn cung cấp + mô hình ngôn ngữ lớn. AI có thể:</p>
        <ul className="ml-5 list-disc space-y-1.5">
          <li>Diễn giải khác nhau cho cùng một lá số ở các lần hỏi khác nhau.</li>
          <li>Bịa thông tin (hallucination) — luôn đối chiếu với nguồn cổ thư đáng tin.</li>
          <li>Không hiểu hoàn cảnh cá nhân thực tế của bạn.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Không thay thế chuyên gia">
        <p>
          <strong>Y tế:</strong> nếu lá số đề cập sức khoẻ, hãy đi khám bác sĩ — đừng dùng kết quả
          tử vi để chẩn đoán hay trì hoãn điều trị.
        </p>
        <p>
          <strong>Pháp lý:</strong> các quyết định liên quan đến hôn nhân, hợp đồng, kiện tụng cần
          luật sư có giấy phép, không dựa vào kết quả &ldquo;ngày tốt&rdquo;.
        </p>
        <p>
          <strong>Tài chính:</strong> đầu tư, kinh doanh, vay nợ cần phân tích thực tế — tử vi không
          dự báo được rủi ro thị trường.
        </p>
        <p>
          <strong>Hôn nhân:</strong> &ldquo;hợp tuổi&rdquo; chỉ là một tham khảo trong văn hoá
          truyền thống. Quyết định kết hôn cần dựa trên hiểu biết thật và phù hợp về giá trị sống,
          tính cách.
        </p>
      </LegalSection>

      <LegalSection title="4. Tự chịu trách nhiệm">
        <p>
          Bạn hoàn toàn tự chịu trách nhiệm về các quyết định và hành động dựa trên kết quả từ Tử Vi
          Số. Trong phạm vi pháp luật cho phép, chúng tôi không chịu trách nhiệm cho thiệt hại trực
          tiếp hoặc gián tiếp phát sinh từ việc sử dụng Dịch vụ.
        </p>
      </LegalSection>

      <LegalSection title="5. Khẩn cấp">
        <p>Nếu bạn hoặc người thân có dấu hiệu khủng hoảng tâm lý, hãy gọi tổng đài hỗ trợ:</p>
        <ul className="ml-5 list-disc space-y-1.5">
          <li>
            <strong>1900-599-958</strong> — Trung tâm Tâm lý ứng dụng (Việt Nam)
          </li>
          <li>
            <strong>115</strong> — Cấp cứu y tế
          </li>
        </ul>
      </LegalSection>
    </LegalLayout>
  );
}
